import { rem } from 'polished'
import { memo } from 'react'
import styled from 'styled-components'
import DropdownChevron from '../../../../LuxKit/Dropdown/DropdownChevron'
import TextLoadingBox from 'LuxKit/Typography/TextLoadingBox'
import Group from 'components/utils/Group'
import VerticalSpacer from '../Spacing/VerticalSpacer'
import LoadingBox from 'components/Common/Loading/LoadingBox'

const FilterPanel = styled(VerticalSpacer)`
  border-bottom: 1px solid ${props => props.theme.palette.neutral.surface.lightForeground};
  padding-bottom: ${rem(16)};
`

const FilterGroupLoader = styled(Group)`
  padding: ${rem(6)} 0;

  >:first-child {
    flex-grow: 1;
  }
`

const CheckboxSkeleton = styled(LoadingBox)`
  width: ${rem(24)};
  height: ${rem(24)};
  flex: 0 0 ${rem(24)};
`

const CheckboxLabelSkeleton = styled(LoadingBox)`
  height: ${rem(24)};
  flex: 1;
`

interface Props {
  type: 'checkbox' | 'slider'
}

function CheckboxLoaderRow() {
  return (
    <Group direction="horizontal" verticalAlign="center" gap={12}>
      <CheckboxSkeleton />
      <CheckboxLabelSkeleton />
    </Group>
  )
}

function FilterPanelLoader(props: Props) {
  const { type } = props

  return <FilterPanel gap={8}>
    <FilterGroupLoader
      direction="horizontal"
      horizontalAlign="space-between"
      gap={8}
    >
      <TextLoadingBox typography="heading6" width="100%" />
      <DropdownChevron open />
    </FilterGroupLoader>
    {type === 'checkbox' && <VerticalSpacer gap={8}>
      <CheckboxLoaderRow />
      <CheckboxLoaderRow />
      <CheckboxLoaderRow />
    </VerticalSpacer>}
    {type === 'slider' && <VerticalSpacer gap={12}>
      <LoadingBox height={24} />
      <Group direction="horizontal" horizontalAlign="stretch" gap={8}>
        <LoadingBox height={48} />
        <LoadingBox height={48} />
      </Group>
    </VerticalSpacer>}
  </FilterPanel>
}

export default memo(FilterPanelLoader)
